import { createContext } from 'react';

const LanguageContext = createContext({
  locale: 'en',
  setLocale: () => {}
});

export default LanguageContext;
